import {
    ElementRef,
    Directive,
    Input,
    TemplateRef,
    Renderer2,
    Injector,
    ComponentFactoryResolver,
    ViewContainerRef,
    NgZone,
    OnInit,
    OnDestroy,
    Inject,
    ChangeDetectorRef,
    ApplicationRef,
  } from '@angular/core';
  
  import { DOCUMENT } from '@angular/common';
  import { NgbPopover, NgbPopoverConfig } from '@ng-bootstrap/ng-bootstrap';
  @Directive({
    selector: '[stickyPopover]',
    exportAs: 'stickyPopover',
  })
  export class StickyPopoverDirective
    extends NgbPopover
    implements OnInit, OnDestroy
  {
    @Input() stickyPopover: TemplateRef<any>;
  
    override popoverTitle: string;
  
    override placement:
      | 'auto'
      | 'top'
      | 'bottom'
      | 'left'
      | 'right'
      | 'top-left'
      | 'top-right'
      | 'bottom-left'
      | 'bottom-right'
      | 'left-top'
      | 'left-bottom'
      | 'right-top'
      | 'right-bottom'
      | (
          | 'auto'
          | 'top'
          | 'bottom'
          | 'left'
          | 'right'
          | 'top-left'
          | 'top-right'
          | 'bottom-left'
          | 'bottom-right'
          | 'left-top'
          | 'left-bottom'
          | 'right-top'
          | 'right-bottom'
        )[];
  
    override triggers: string;
    override container: string;
    ngpPopover: TemplateRef<any>;
    isresizing:boolean= false;
    canClosePopover: boolean;
  
    override toggle(): void {
      super.toggle();
    }
  
    override isOpen(): boolean {
      return super.isOpen();
    }
  
    constructor(
      private _elRef: ElementRef,
      private _render: Renderer2,
      injector: Injector,
      componentFactoryResolver: ComponentFactoryResolver,
      viewContainerRef: ViewContainerRef,
      config: NgbPopoverConfig,
      ngZone: NgZone,
      changeRef: ChangeDetectorRef,
      applicationRef: ApplicationRef,
      @Inject(DOCUMENT) _document: any
    ) {
      super(
        _elRef,
        _render,
        injector,
        componentFactoryResolver,
        viewContainerRef,
        config,
        ngZone,
        _document,
        changeRef,
        applicationRef
      );
      this.triggers = 'manual';
      this.popoverTitle = '';
      this.container = 'body';
    }
  
    override ngOnInit(): void {
      super.ngOnInit();
      this.ngbPopover = this.stickyPopover;


      this._render.listen(this._elRef.nativeElement, 'mouseenter', () => {
        this.canClosePopover = true;
        this.open();
      });
  
      this._render.listen(
        this._elRef.nativeElement,
        'mouseleave',
        () => {
          setTimeout(() => {
            if (this.canClosePopover && !this.isresizing) {
              super.close();
            }
          }, 100);
        }
      );
  
      this._render.listen(this._elRef.nativeElement, 'click', () => {
        
        if(this.canClosePopover){
          super.close()
        }else{
          this.open();
        }
        this.canClosePopover = !this.canClosePopover;
      });
    }
  
    override ngOnDestroy(): void {
      super.ngOnDestroy();
    }
  
    override open() {
      super.open();
      setTimeout(() => {
        const popover = window.document.querySelector('.popover');
        this._render.listen(popover, 'mouseover', () => {
          this.canClosePopover = false;
        });
  
        this._render.listen(popover, 'mouseout', () => {
          this.canClosePopover = true;
          setTimeout(() => {
            if (this.canClosePopover && !this.isresizing) {
              super.close();
            }
          }, 0);
        });

        
      this._render.listen(popover, 'mousedown', () => {
        console.log(this.isresizing)
        this.isresizing = true
      });

      this._render.listen(popover, 'mouseup', () => {
        console.log(this.isresizing)
        this.isresizing = false
      });

      this._render.listen(popover, 'mousemove', () => {
        this._render.listen(popover,'mouseenter',()=>{
          if(this.isresizing){
            this.isresizing = false;
          }
        })
      });
  
      }, 0);
    }
  
    override close() {
      // super.close();
    }
  }
  